import axios from 'axios';

let API_URL;
if (location.hostname == 'app.vex.ma') {
  API_URL = 'https://api.vex.ma/api';
} else if (location.hostname == 'vex.speedliv.com') {
  API_URL = 'https://api-vex.speedliv.com/api';
} else {
  API_URL = 'http://' + location.hostname + ':3020/api';
  //API_URL = "http://167.71.1.17:3021/api";
}

const token = window.localStorage.getItem('id_token');

const HTTP = axios.create({
  baseURL: API_URL,
  headers: {
    'X-Auth-Token': token,
  },
});

HTTP.interceptors.response.use(
  function(response) {
    // Do something with response data
    if (response.data && response.data.status == 401 && token) {
      window.localStorage.removeItem('id_token');
      window.location.href = '/';
    } else if (response.data && response.data.status == 400 && token) {
      alert(response.data.content);
    } else {
      return response;
    }
  },
  
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  },
);

export default HTTP;
